export default __webpack_public_path__ + "static/media/directional_devices.b6de671e.svg";